import { v4 as uuid4 } from 'uuid';
import { me } from '../../../test.data';
import { Channel, GroupedMessage } from '../../../types/channel.types';
import { groupMessages } from '../../../utils/common.util';
import Button from '../../button/v2/button';
import Avatar from '../../images/avatar';
import { HStack, VStack } from '../../layouts/stack.layout';
import Heading from '../../typography/v2/heading';
import MessageBox from './message-box';
import MessageContainer from './message.container';
import Container from '../container';
import { TagsContainer } from '../tags.container';

const styles = {
  container: 'w-full relative flex flex-col border-l border-dark-gray',
  header:
    'w-full bg-[1C1C1E]/50 backdrop-blur-xl sticky mobile:top-[73px] tablet-lg:top-[59px] z-20',
  content: 'mobile:px-2 tablet-lg:px-[40px]',
  footer:
    'sticky mobile:bottom-[59px] tablet-lg:bottom-0 bg-[1C1C1E]/75 backdrop-blur-2xl border-t border-dark-gray',
  'header-wrapper': 'mobile:px-2 tablet-lg:px-[40px] py-2 bg-secondary/[5%]',
  'header-details': 'ml-5 justify-between flex-1 basis-auto items-center',
};

type Props = {
  channel?: Channel;
  trigger: Function;
};

export default function ChannelContainer({ channel, trigger }: Props) {
  const groupedMessages = groupMessages(channel?.messages || []);

  return (
    <Container extensions={styles.container}>
      <header className={styles.header}>
        <HStack extensions={styles['header-wrapper']}>
          <Avatar
            size={'sm'}
            url={channel?.backgroundImage || ''}
            alt={channel?.title || ''}
          />
          <HStack extensions={styles['header-details']} justify="between">
            <VStack gap="xs">
              <Heading variant="secondary">{channel?.title}</Heading>
              <TagsContainer tags={channel?.tags} />
            </VStack>
            <Button
              onClick={() => trigger({ id: channel?.id })}
              asIcon="dots"
              withButtonStyle
              color="glass"
              size="sm"
            />
          </HStack>
        </HStack>
      </header>
      <Container extensions={styles.content}>
        <VStack gap="md">
          {groupedMessages.map((groupedMessage: GroupedMessage) => (
            <MessageContainer
              key={uuid4()}
              user={groupedMessage.user}
              messages={groupedMessage.messages}
              owned={groupedMessage.user.username === me.username}
            />
          ))}
        </VStack>
      </Container>
      <Container extensions={styles.footer}>
        <MessageBox />
      </Container>
    </Container>
  );
}
